import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Checkbox, Column, Panel, Row, Select } from "../../../../components";
import DatePicker from "react-datepicker";
import { RootState } from "../../../../shared/store";
import { PolicyDtoRead } from "../../../model/PolicyDtoRead";
import { updateSelectedPolicyDetails } from "../../../customer-slice/Customer-slice";
import * as constant from '../../../../shared/util/constant'
import { CustomerPolicyDetailLabels as cstPolicyDetailLabel } from '../../../../shared/util/label';
import { Col, Container, FloatingLabel, Form, InputGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import { CommonUtility } from "../../../../Services/CommonUtility";
import "./CustomerBasicPolicyInfo.scss";
import { SelectOption } from "../../../../shared/components/input";
import CustomerPolicyActionService from "../../customer-policy-action/CustomerPolicyActionService";
import Logger from "../../../../shared/services/Logger";
import { updateLookupData } from "../../../customer-slice/Customer-lookup-slice";

export interface ICustomerBasicPolicyInfo {
    customerId: string;
    validationErrors?: any;
    tabindex?: number;
}

const CustomerBasicPolicyInfo: React.FunctionComponent<ICustomerBasicPolicyInfo> = (props) => {
    
     const { validationErrors } = props;
    // Get policyId and polEventId from Redux
    const { policyId, polEventId } = useSelector((state: RootState) => ({
        policyId: state.customerSlice.policyId,
        polEventId: state.customerSlice.polEventId
    }));
    let tbindex = props.tabindex;
    const [formValidation, setFormValidation] = useState<any>({});
    const dispatch = useDispatch()
    let customerpolicyDetail = useSelector((state: RootState) => state?.customerSlice);
    let customerSliderState = useSelector((state: RootState) => state?.CustomerSliderState);
    const policyTypeData = useSelector((state: RootState) => state?.LookupState.policyTypeList);
    const policyTermStatusData = useSelector((state: RootState) => state?.LookupState.policyTermStatusList);
    const policyBusinessTypeData = useSelector((state: RootState) => state?.LookupState.policyBusinessTypeList);
    const policyPaymentPlanData = useSelector((state: RootState) => state?.LookupState.policyPaymentPlanList);
    const parentCompanyData = useSelector((state: RootState) => state?.LookupState.parentCompaniesList);
    const writingCompanyData = useSelector((state: RootState) => state?.LookupState.writingCompaniesList);
    const sourceData = useSelector((state: RootState) => state?.LookupState.sourceTypeList);  
    const policyDetailKey = CommonUtility.getPolicyDetailKey(policyId, polEventId);
    const policyDetails = customerpolicyDetail.selectedPolicyDetails?.[policyDetailKey] || {} as PolicyDtoRead;
    const priorPolicies = [...customerSliderState.activityPage.policiesForSelect];
    const policyTypeList = [...policyTypeData];
    const policyTermStatusList = [...policyTermStatusData];
    const policyBusinessTypeList = [...policyBusinessTypeData];
    const policyPaymentPlanList = [...policyPaymentPlanData];
     const parentCompanyList = [...parentCompanyData];
    const writingCompanyList = [...writingCompanyData];
    const sourceTypeList = [...sourceData];
    const [sourceId, setSourceId] = useState<SelectOption[]>([]);
    const sourceTypeLookupValueData = useSelector((state: RootState) => state?.LookupState.sourceTypeLookupValue);
    const policyActionService = new CustomerPolicyActionService();
    const companiesList = useSelector((state: RootState) => state?.LookupState.companyList);
    const [filteredWritingCompanies, setFilteredWritingCompanies] = useState<SelectOption[]>(writingCompanyList);
    const [isFullTermPremiumFocused, setIsFullTermPremiumFocused] = useState(false);
    const [fullTermPremiumInput, setFullTermPremiumInput] = useState<string>('');

    const onEntityFieldChange = (propName: string, value: string | Date | boolean | number) => {
        let updatePolicyDetails = {
            ...policyDetails,          
            [propName]: value,
        };

        dispatch(updateSelectedPolicyDetails({
            policyId,
            polEventId,
            policyDetails: updatePolicyDetails
        }));
    }

    const handleParentCompanyChange = async(value: string | null) => {
        if (!value) {
            // If parent company is deselected, do not show any writing companies
            setFilteredWritingCompanies([]);
        } else {
            // Filter writing companies based on selected parent company
            const filteredCompanies = companiesList
                .filter(company => company.parentId === value && company.parentId !== company.value);
            
            // If no companies found for the parent, do not show any writing companies
            setFilteredWritingCompanies(filteredCompanies.length > 0 ? filteredCompanies : []);
        }

        // Update parent company and reset writing company
        let updatePolicyDetails = {
            ...policyDetails,
            ["companyId"]: value || null,
            ["writingCompanyId"]: null // Reset writing company when parent company changes
        };
        
        dispatch(updateSelectedPolicyDetails({
            policyId,
            polEventId,
            policyDetails: updatePolicyDetails
        }));
    };

    const handleWritingCompanyChange = (value: string | null) => {
        if (!value) {
            let updatePolicyDetails = {
                ...policyDetails,
                ["writingCompanyId"]: null
            };
            
            dispatch(updateSelectedPolicyDetails({
                policyId,
                polEventId,
                policyDetails: updatePolicyDetails
            }));

            // If parent company is selected, show filtered list, otherwise show all
            if (policyDetails.companyId) {
                const filteredCompanies = companiesList
                    .filter(company => company.parentId === policyDetails.companyId && company.parentId !== company.value);
                setFilteredWritingCompanies(filteredCompanies);
            } else {
                setFilteredWritingCompanies([]);
            }
        } else {
            // Find the selected writing company
            const selectedCompany = companiesList.find(company => company.value === value && company.value != company.parentId);
            
            if (selectedCompany) {
                // Update writing company
                let updatePolicyDetails = {
                    ...policyDetails,
                    ["writingCompanyId"]: value
                };
                
                dispatch(updateSelectedPolicyDetails({
                    policyId,
                    polEventId,
                    policyDetails: updatePolicyDetails
                }));
            }
        }
    };

      const handleSourceTypeChange = async(value: string) => {
            await loadSourceList(value);
            dispatch(updateSelectedPolicyDetails({
                policyId,
                polEventId,
                policyDetails: {
                    ...policyDetails,
                    sourceTypeId: value,
                    sourceId: null,
                }
            }));
        };
    
        const loadSourceList = async (sourceTypeId: string) => {
            if (!sourceTypeId) {
                setSourceId([]);
                return;
            }
            try {
                let sourceTypeLookupValue = sourceTypeLookupValueData?.[sourceTypeId];           
                if (sourceTypeLookupValue === null || sourceTypeLookupValue === undefined) {
                    sourceTypeLookupValue = await policyActionService.getSourceTypeLookupValue(sourceTypeId);
                }
                if (sourceTypeLookupValue) {
                    dispatch(
                        updateLookupData({
                            data: {
                                sourceTypeId: sourceTypeId,
                                sourceTypeLookupValue: sourceTypeLookupValue,
                            },
                            type: constant.SlicerLookUpConstant.Source_Type_Lookup_Value,
                        })
                    );
                    const sourceList = await policyActionService.getSourceList(sourceTypeLookupValue.lookupCode);
                    setSourceId(sourceList || []);
                } else {
                    Logger.logError("No source type found for ID:", sourceTypeId);
                    setSourceId([]);
                }
            } catch (error) {
                Logger.logError("Error fetching source type lookup value:", error);
                setSourceId([]);
            }
        };
    

    useEffect(() => {        
        if (policyDetails?.commisionMethod !== "A" && policyDetails?.commisionPercentage !== undefined) {
            onEntityFieldChange('commisionPercentage', undefined);
        }
        if (policyDetails?.commisionMethod !== "F" && policyDetails?.commisionFlatAmount !== undefined) {
            onEntityFieldChange('commisionFlatAmount', undefined);
        }
    }, [policyDetails?.commisionMethod]);

      // Set validation errors from props to formValidation state
        useEffect(() => {
            if (validationErrors) {
                setFormValidation(validationErrors);
            }
        }, [validationErrors]);

        useEffect( () => {
            fetchSourceId();
        },[policyDetails?.sourceTypeId]);

        // Set initial filtered writing companies based on selected parent company
        useEffect(() => {
            if (policyDetails?.companyId && companiesList.length > 0) {
                const filteredCompanies = companiesList
                    .filter(company => company.parentId === policyDetails.companyId && company.parentId !== company.value);
                setFilteredWritingCompanies(filteredCompanies);
            }
        }, [policyDetails?.companyId, companiesList]);

        const fetchSourceId = async() =>{
            if(policyDetails?.sourceTypeId)          
                        {
                          await loadSourceList(policyDetails?.sourceTypeId);
                        }
        }

    return (
        <>
            <Container fluid id="basic-policy-detail-container">
                <Row>
                    <Column lg={9} md={9}>
                        <Row>
                            <Column lg={6} md={6}>
                                <Select
                                    id='policyTermStatus'
                                    label={cstPolicyDetailLabel.STATUS}
                                    tabIndex={tbindex++}
                                    options={policyTermStatusList}
                                    defaultSelected={policyTermStatusList?.filter(({ value }) =>
                                        value === policyDetails?.policyTermStatusId
                                    )}
                                    onChange={(values) => {
                                        onEntityFieldChange('policyTermStatusId', values[0] as string)
                                    }}
                                    placeholder={constant.PLEASE_SELECT}
                                    multiple={false}
                                    showAsFloatingLabel={true}
                                    className='mb-3'
                                />
                            </Column>
                            <Column lg={6} md={6}>
                                <FloatingLabel
                                    controlId="policyNumber"
                                    className="mb-3"
                                    label={<>{cstPolicyDetailLabel.POLICY_NUMBER}<span className="text-danger ms-1">*</span></>}
                                    aria-required="true"
                                >
                                    <Form.Control
                                        tabIndex={tbindex++}                                        
                                        type="text"
                                        name="policyNumber"
                                        placeholder={cstPolicyDetailLabel.POLICY_NUMBER}
                                        value={policyDetails?.policyNumber || ''}
                                        onKeyDown={(event) => {
                                            if (event.key === ' ' || event.key === '_') event.preventDefault();
                                        }}
                                        onChange={(event) => onEntityFieldChange('policyNumber', event.currentTarget.value.replace(/[\s_]/g, ''))}
                                        onPaste={(event) => {
                                            event.preventDefault();
                                            const pasted = event.clipboardData.getData('text').replace(/[\s_]/g, '');
                                            onEntityFieldChange('policyNumber', pasted);
                                        }}
                                        onBlur={(event) => onEntityFieldChange('policyNumber', event.currentTarget.value.replace(/[\s_]/g, ''))}
                                        required={true}  
                                        isInvalid={formValidation['policyNumber']?.isValid == false}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                            {formValidation['policyNumber']?.warningText}
                                    </Form.Control.Feedback>
                                </FloatingLabel>
                            </Column>
                        </Row>
                        <Row>
                            <Column lg={4} md={4}>
                                <InputGroup
                                    className={`mb-3${policyDetails.polEffDate ? ' effective-date-disabled' : ''}`}
                                >
                                    <InputGroup.Text>
                                        {cstPolicyDetailLabel.EFFECTIVE_DATE}
                                    </InputGroup.Text>
                                    <DatePicker
                                        dateFormatCalendar="LLLL yyyy"
                                        tabIndex={tbindex++}
                                        dropdownMode="scroll"
                                        selected={CommonUtility.datetimeToDateOnlyObject(policyDetails.polEffDate)}
                                        onChange={(date) => onEntityFieldChange('polEffDate', date)}
                                        className={`form-control${policyDetails.polEffDate ? ' gray-out' : ''}`}
                                        disabled={!!policyDetails.polEffDate}
                                    />
                                    <InputGroup.Text>
                                        <i className="bi bi-calendar3"></i>
                                    </InputGroup.Text>
                                </InputGroup>
                            </Column>
                            <Column lg={4} md={4}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text>
                                            {<> {cstPolicyDetailLabel.EXPIRATION_DATE}<span className="text-danger ms-1">*</span></>}
                                    </InputGroup.Text>
                                    <DatePicker
                                        dateFormatCalendar="LLLL yyyy"
                                        tabIndex={tbindex++}
                                        dropdownMode="scroll"
                                        selected={CommonUtility.datetimeToDateOnlyObject(policyDetails.polExpDate)}
                                        onChange={(date) => onEntityFieldChange('polExpDate', date)}
                                        className={`form-control ${policyDetails.polExpDate ? '' : 'is-invalid block-padding'}`}
                                        isRequired={true}
                                    />
                                    <InputGroup.Text>
                                        <i className="bi bi-calendar3"></i>
                                    </InputGroup.Text>
                                    {(!policyDetails?.polExpDate || policyDetails?.polExpDate.toString().trim() === "") && (
                                        <div className="mt-1 cst-error text-danger invalid-feedback" style={{ display: "block" }}>
                                            {formValidation['polExpDate']?.warningText}
                                        </div>
                                    )}
                                </InputGroup>
                            </Column>
                            <Column lg={1} md={1}>
                                <Checkbox
                                    id='continousPolicy'
                                    className="checkbox-continuous"
                                    tabIndex={(tbindex++).toString()}
                                    label={cstPolicyDetailLabel.CONTINOUS}
                                    checked={policyDetails?.isContinuous || false}
                                    onChange={(event) => onEntityFieldChange('isContinuous', !policyDetails?.isContinuous)}
                                />
                            </Column>
                            <Column lg={3} md={3}>
                                <Select
                                    id='policyPaymentPlan'
                                    label={cstPolicyDetailLabel.FREQUENCY}
                                    options={policyPaymentPlanList}
                                    tabIndex={tbindex++}
                                    defaultSelected={policyPaymentPlanList?.filter(({ value }) =>
                                        value === policyDetails?.payPId
                                    )}
                                    onChange={(values) => {
                                        onEntityFieldChange('payPId', values[0] as string)
                                    }}
                                    placeholder={constant.PLEASE_SELECT}
                                    multiple={false}
                                    showAsFloatingLabel={true}
                                    className='mb-3'
                                />
                            </Column>
                        </Row>
                        <Row>
                            <Column lg={4} md={4}>
                                <Select
                                    id='policyBusinessType'
                                    label={cstPolicyDetailLabel.TYPE_OF_BUSINESS}
                                    options={policyBusinessTypeList}
                                    tabIndex={tbindex++}
                                    defaultSelected={policyBusinessTypeList?.filter(({ value }) =>
                                        value === policyDetails?.typeOfBusId
                                    )}
                                    onChange={(values) => {
                                        onEntityFieldChange('typeOfBusId', values[0] as string)
                                    }}
                                    placeholder={constant.PLEASE_SELECT}
                                    multiple={false}
                                    showAsFloatingLabel={true}
                                    className='mb-3'
                                    isRequired={true}
                                    isInvalid={formValidation['typeOfBusId']?.isValid == false}
                                    invalidWarning={formValidation['typeOfBusId']?.warningText}
                                />
                            </Column>
                            <Column lg={4} md={4}>
                                <Select
                                    id='policyType'
                                    label={cstPolicyDetailLabel.POLICY_TYPE}
                                    options={policyTypeList}
                                    tabIndex={tbindex++}
                                    defaultSelected={policyTypeList?.filter(({ value }) =>
                                        value === policyDetails?.policyTypeId
                                    )}
                                    onChange={(values) => {
                                        onEntityFieldChange('policyTypeId', values[0] as string)
                                    }}
                                    placeholder={constant.PLEASE_SELECT}
                                    multiple={false}
                                    showAsFloatingLabel={true}
                                    className='mb-3'
                                    isRequired={true}
                                    isInvalid={formValidation['policyTypeId']?.isValid == false}
                                    invalidWarning={formValidation['policyTypeId']?.warningText}
                                />
                            </Column>
                            <Column lg={4} md={4}>
                                <Select
                                    id='priorPolicy'
                                    label={cstPolicyDetailLabel.PRIOR_POLICY}
                                    tabIndex={tbindex++}
                                    options={priorPolicies}
                                    defaultSelected={priorPolicies?.filter(({ value }) =>
                                        value === policyDetails?.priorPolicyId
                                    )}
                                    onChange={(values) => {
                                        onEntityFieldChange('priorPolicyId', values[0] as string)
                                    }}
                                    placeholder={constant.PLEASE_SELECT}
                                    multiple={false}
                                    showAsFloatingLabel={true}
                                    className='mb-3'
                                />
                            </Column>
                        </Row>
                        <Row>
                            <Column lg={4} md={4}>
                                <FloatingLabel
                                    controlId="aPlusReferenceNumber"
                                    className="mb-3"
                                    label={cstPolicyDetailLabel.APLUSNUMBER}
                                >
                                    <Form.Control
                                        tabIndex={tbindex++}
                                        type="text"
                                        name="aPlusReferenceNumber"
                                        placeholder={cstPolicyDetailLabel.APLUSNUMBER}
                                        value={policyDetails?.aPlusReferenceNumber || ''}
                                        onChange={(event) => onEntityFieldChange('aPlusReferenceNumber', event.currentTarget.value)}
                                    />
                                </FloatingLabel>
                            </Column>
                        </Row>
                        <Row>
                            <Column lg={4} md={4}>
                                <FloatingLabel
                                    controlId="description"
                                    className="mb-3"
                                    label={cstPolicyDetailLabel.DESCRIPTION}
                                >
                                    <Form.Control
                                        tabIndex={tbindex++}
                                        type="text"
                                        name="description"
                                        placeholder={cstPolicyDetailLabel.DESCRIPTION}
                                        value={policyDetails?.description || ''}
                                        onChange={(event) => onEntityFieldChange('description', event.currentTarget.value)}
                                    />
                                </FloatingLabel>
                            </Column>
                            <Column lg={4} md={4}>
                            <OverlayTrigger
                                        placement="bottom"
                                        trigger={"hover"}
                                        delay={{show:100, hide:0}}
                                        overlay={
                                            <Tooltip id="inception-date-tooltip">
                                                {constant.CUSTOMER_INCEPTION_DATE_FIELDS_ERROR}
                                            </Tooltip>
                                        }
                                    >
                                <InputGroup className="mb-3">
                                    <InputGroup.Text>
                                        {cstPolicyDetailLabel.INCEPTION_DATE}
                                    </InputGroup.Text>
                                    
                                        <div>
                                            <DatePicker
                                                dateFormatCalendar="LLLL yyyy"
                                                tabIndex={tbindex++}
                                                dropdownMode="scroll"
                                                selected={CommonUtility.datetimeToDateOnlyObject(policyDetails.inceptionDate)}
                                                onChange={(date) => onEntityFieldChange('inceptionDate', date)}
                                                className={`form-control ${formValidation['inceptionDate']?.warningText ? 'is-invalid pe-0' : ''}`}
                                            />
                                        </div>
                                    
                                    <InputGroup.Text>
                                        <i className="bi bi-calendar3"></i>
                                    </InputGroup.Text>
                                </InputGroup>
                                </OverlayTrigger>
                                 {formValidation['inceptionDate'] && (
                                        <div className="mt-1 cst-error text-danger invalid-feedback" style={{ display: "block" }}>
                                            {formValidation['inceptionDate']?.warningText}
                                        </div>
                                )}
                            </Column>
                            <Column lg={1} md={1}>
                                <Checkbox
                                    id='isAudit'
                                    className="checkbox-audit"
                                    tabIndex={tbindex++}
                                    label={cstPolicyDetailLabel.AUDITABLE}
                                    checked={policyDetails?.isAudit || false}
                                    onChange={(event) => onEntityFieldChange('isAudit', !policyDetails?.isAudit)}
                                />
                            </Column>
                            <Column lg={3} md={3}>
                                <FloatingLabel
                                    controlId="fullTermPremium"
                                    className="mb-3"
                                    label="Full Term Premium ($)"
                                >
                                    <Form.Control
                                        type="text"
                                        inputMode="decimal"
                                        name="fullTermPremium"
                                        tabIndex={tbindex++}
                                        placeholder="Full Term Premium ($)"
                                        value={
                                          isFullTermPremiumFocused
                                            ? fullTermPremiumInput
                                            : policyDetails?.fullTermPremium == null
                                              ? ''
                                              : Number(policyDetails.fullTermPremium).toFixed(2)
                                        }
                                        onFocus={() => {
                                            setFullTermPremiumInput(policyDetails?.fullTermPremium == null ? '' : policyDetails.fullTermPremium.toString());
                                            setIsFullTermPremiumFocused(true);
                                        }}
                                        onBlur={() => setIsFullTermPremiumFocused(false)}
                                        onChange={(event) => {
                                            const inputValue = event.target.value;
                                            if (CommonUtility.isValidDecimalWithNegativeUpto2Limit(inputValue)) {
                                                setFullTermPremiumInput(inputValue);
                                                onEntityFieldChange('fullTermPremium', CommonUtility.parseDecimalOrZero(inputValue));
                                            }
                                        }}
                                        // isInvalid={formValidation['fullTermPremium']?.isValid === false}
                                    />
                                    {/* {formValidation['fullTermPremium']?.isValid === false && (
                                        <Form.Control.Feedback type="invalid">
                                            {formValidation['fullTermPremium']?.warningText}
                                        </Form.Control.Feedback>
                                    )} */}
                                </FloatingLabel>
                            </Column>
                        </Row>                
                        <Row>
                            <Column lg={6} md={6}>
                                <Select
                                    id='insuranceCompany'
                                    label={cstPolicyDetailLabel.PARENT_COMPANY}
                                    options={parentCompanyList}
                                    tabIndex={tbindex++}
                                    defaultSelected={parentCompanyList?.filter(({ value }) =>
                                        value === policyDetails?.companyId
                                    )}
                                    onChange={(values) => {
                                        handleParentCompanyChange(values[0] as string);
                                    }}
                                    placeholder={constant.PLEASE_SELECT}
                                    multiple={false}
                                    showAsFloatingLabel={true}
                                    className='mb-3'
                                    isRequired={true}
                                    isInvalid={formValidation['companyId']?.isValid == false}
                                    invalidWarning={formValidation['companyId']?.warningText}
                                />
                            </Column>
                            <Column lg={6} md={6}>
                                <Select
                                    id='writingCompanyId'
                                    label={cstPolicyDetailLabel.WRITING_COMPANY}
                                    tabIndex={tbindex++}
                                    options={filteredWritingCompanies}
                                    defaultSelected={filteredWritingCompanies?.filter(({ value }) =>
                                        value === policyDetails?.writingCompanyId
                                    )}
                                    onChange={(values) => {
                                        handleWritingCompanyChange(values[0] as string);
                                    }}
                                    placeholder={constant.PLEASE_SELECT}
                                    multiple={false}
                                    showAsFloatingLabel={true}
                                    className='mb-3'
                                    isRequired={true}
                                    isInvalid={formValidation['writingCompanyId']?.isValid == false}
                                    invalidWarning={formValidation['writingCompanyId']?.warningText}
                                />
                            </Column>                
                        </Row>
                        <Row>
                                <Column lg={6} md={6}>
                                <Select
                                    id='sourceType'
                                    label={cstPolicyDetailLabel.SOURCE_TYPE}
                                    options={sourceTypeList}
                                    tabIndex={tbindex++}
                                    defaultSelected={sourceTypeList?.filter(({ value }) =>
                                        value === policyDetails?.sourceTypeId
                                    )}                           
                                    onChange={(values) => handleSourceTypeChange(values[0] as string)}
                                    placeholder={constant.PLEASE_SELECT}
                                    multiple={false}
                                    showAsFloatingLabel={true}
                                    className='mb-3'
                                    isRequired={true}
                                    isInvalid={formValidation['sourceType']?.isValid == false}
                                    invalidWarning={formValidation['sourceType']?.warningText}
                                />
                            </Column>
                            <Column lg={6} md={6}>
                                <Select
                                    id='source'
                                    label={cstPolicyDetailLabel.SOURCE}
                                    options={sourceId}
                                    tabIndex={tbindex++}
                                    defaultSelected={sourceId?.filter(({ value }) =>
                                        value === policyDetails?.sourceId
                                    )}
                                    onChange={(values) => {
                                        onEntityFieldChange('sourceId', values[0] as string)
                                    }}
                                    placeholder={constant.PLEASE_SELECT}
                                    multiple={false}
                                    showAsFloatingLabel={true}
                                    className='mb-3'
                                    isRequired={true}
                                    isInvalid={formValidation['sourceId']?.isValid == false}
                                    invalidWarning={formValidation['sourceId']?.warningText}
                                />
                            </Column>
                        </Row>               
                    </Column>
                    <Column lg={3} md={3}>
                        <Row>
                            <Column lg={12} md={12}>
                                <h6 className="cst-lss-section-header">{cstPolicyDetailLabel.AGENCY_NEGOTIATED_COMMISSIONS}</h6>
                            </Column>
                        </Row>
                        <Row>
                            <Column lg={12} md={12}>
                                <Form.Check
                                    type="radio"
                                    id="noneCommissionMethod"
                                    tabIndex={tbindex++}
                                    label={cstPolicyDetailLabel.NONE}
                                    name="commissionMethod"
                                    value={null}
                                    checked={!policyDetails?.commisionMethod}
                                    onChange={() => onEntityFieldChange('commisionMethod', undefined)}
                                />
                            </Column>
                        </Row>
                        <br></br>
                        <Row>
                            <Column lg={6} md={6}>
                                <Form.Check
                                    type="radio"
                                    id="premiumPercentCommissionMethod"
                                    tabIndex={tbindex++}
                                    label={cstPolicyDetailLabel.PERCENT_OF_PREMIUM_FEES}
                                    name="commissionMethod"
                                    value="A"
                                    checked={policyDetails?.commisionMethod === "A"}
                                    onChange={(event) => onEntityFieldChange('commisionMethod', event.target.value)}
                                />
                            </Column>
                            <Column lg={6} md={6}>
                                <FloatingLabel
                                    controlId="percent"
                                    className="mb-3"
                                    label={cstPolicyDetailLabel.PERCENT}
                                >
                                    <Form.Control
                                        type="text"
                                        name="percent"
                                        placeholder={cstPolicyDetailLabel.PERCENT}
                                        tabIndex={tbindex++}
                                        value={policyDetails?.commisionPercentage || ''}
                                        onChange={(event) => {
                                            const inputValue = event.currentTarget.value; 
                                            if (CommonUtility.isValidNumber(inputValue) || inputValue === '') {
                                                if (inputValue === '') {
                                                    onEntityFieldChange('commisionPercentage', undefined);
                                                } else {
                                                    onEntityFieldChange('commisionPercentage', inputValue);
                                                }
                                            }
                                        }}
                                        disabled={!policyDetails?.commisionMethod || policyDetails?.commisionMethod !== "A"}
                                    />
                                </FloatingLabel>
                            </Column>
                        </Row>
                        <br></br>
                        <Row>
                            <Column lg={6} md={6}>
                                <Form.Check
                                    type="radio"
                                    id="flatRateCommissionMethod"
                                    label={cstPolicyDetailLabel.FLAT_RATE}
                                    tabIndex={tbindex++}
                                    name="commissionMethod"
                                    value="F"
                                    checked={policyDetails?.commisionMethod === "F"}
                                    onChange={(event) => onEntityFieldChange('commisionMethod', event.target.value)}
                                />
                            </Column>
                            <Column lg={6} md={6}>
                                <FloatingLabel
                                    controlId="amount"
                                    className="mb-3"
                                    label={cstPolicyDetailLabel.AMOUNT}
                                >
                                    <Form.Control
                                        type="text"
                                        name="amount"
                                        tabIndex={tbindex++}
                                        placeholder={cstPolicyDetailLabel.AMOUNT}
                                        value={policyDetails?.commisionFlatAmount || ''}
                                        onChange={(event) => {
                                            const inputValue = event.currentTarget.value; 
                                            if (CommonUtility.isValidNumber(inputValue) || inputValue === '') {
                                                if (inputValue === '') {
                                                    onEntityFieldChange('commisionFlatAmount', undefined);
                                                } else {
                                                    onEntityFieldChange('commisionFlatAmount', inputValue);
                                                }
                                            }
                                        }}
                                        disabled={!policyDetails?.commisionMethod || policyDetails?.commisionMethod !== "F"}
                                    />
                                </FloatingLabel>
                            </Column>
                        </Row>
                    </Column>
                </Row>
            </Container>
        </>
    )
}

export default CustomerBasicPolicyInfo;